import script from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=069631da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069631da"]])

export default __exports__